// extracted by mini-css-extract-plugin
export default {"solid":"NdfLZMUs1sOFcHy_Nu9D"};